import UserRoutes from './route-types.js'

const moduleId = 'A056'

const UserListView = () => import('./UserListView')
const UserView = () => import('./UserView')
const UserDetail = () => import('./UserDetail')
const UserProfile = () => import('./UserProfile')
const UserAccessControl = () => import('./UserAccessControl')
const UserAccessRestriction = () => import('./UserAccessRestriction')
// const UserView = (r) => require.ensure([], () => r(require('./UserView.vue')), 'user-detail-chunk')

export default [
  {
    path: UserRoutes.UserListView.path,
    name: UserRoutes.UserListView.name,
    component: UserListView,
    meta: {
      id: moduleId,
      route: 'listing',
      title: 'User',
      name: 'User',
      access: {
        isAdd: true
      }
    }
  },
  {
    path: UserRoutes.UserView.path,
    name: UserRoutes.UserView.name,
    component: UserView,
    props: (route) => ({
      isNew: route.meta.isNew,
      returnUrl: route.query.returnUrl || route.meta.returnUrl
    }),
    meta: {
      id: moduleId,
      route: 'header',
      title: 'User',
      isNew: false
    },
    children: [
      {
        path: UserRoutes.UserDetail.path,
        name: UserRoutes.UserDetail.name,
        component: UserDetail,
        meta: {
          id: moduleId,
          title: 'User Detail',
          name: 'UserDetail',
          access: {
            isEdit: true
          }
        }
      },
      {
        path: UserRoutes.UserProfile.path,
        name: UserRoutes.UserProfile.name,
        component: UserProfile,
        meta: {
          id: moduleId,
          title: 'User Profile',
          name: 'UserProfile',
          access: {
            isEdit: true
          }
        }
      },
      {
        path: UserRoutes.UserAccessControl.path,
        name: UserRoutes.UserAccessControl.name,
        component: UserAccessControl,
        meta: {
          id: moduleId,
          title: ' Access Control',
          name: 'UserAccessControl',
          access: {
            isEdit: true
          }
        }
      },
      {
        path: UserRoutes.UserAccessRestriction.path,
        name: UserRoutes.UserAccessRestriction.name,
        component: UserAccessRestriction,
        meta: {
          id: moduleId,
          title: ' Access Restriction',
          name: 'UserAccessRestriction',
          access: {
            isEdit: true
          }
        }
      }
    ]
  }
]
